//Menu item active
var url = window.location.pathname;

//Home
if (url == '/') {
    $('.main-navigation li.level1').removeClass('current-menu-item');
    $('.main-navigation li.level1#menu-item-accueil').addClass('current-menu-item');
}
//Declration litige
else if (window.location.href.indexOf("declaration") > -1) {
    $('.main-navigation li.level1').removeClass('current-menu-item');
    $('.main-navigation li.level1#menu-item-declarer').addClass('current-menu-item');
}
//Suivre mon dossier
else if (window.location.href.indexOf("suivre-mon") > -1) {
    $('.main-navigation li.level1').removeClass('current-menu-item');
    $('.main-navigation li.level1#menu-item-suivre').addClass('current-menu-item');
}
//Suivi de dossier
else if (window.location.href.indexOf("suivi") > -1) {
    $('.main-navigation li.level1').removeClass('current-menu-item');
    $('.main-navigation li.level1#menu-item-suivre').addClass('current-menu-item');
}

//Hub
if(url.indexOf("hub") !== -1) {
    //Déclarer un litige
    if (url.indexOf("declaration") !== -1){
        $('.main-navigation li.level1').removeClass('current-menu-item');
        $('.main-navigation li.level1#menu-item-declarer').addClass('current-menu-item');
    }
    //Suivre dossier
    else if (url.indexOf("suivre-mon-dossier") !== -1) {
        $('.main-navigation li.level1').removeClass('current-menu-item');
        $('.main-navigation li.level1#menu-item-suivre').addClass('current-menu-item');
    }
    //Espace assuré
    else if ( (url.indexOf("espace-assure") !== -1) || (url.indexOf("suivi") !== -1) ) {
        $('.main-navigation li.level1').removeClass('current-menu-item');
        $('.main-navigation li.level1#menu-item-suivre').addClass('current-menu-item');
    }
    //Basedoc
    else if (url.indexOf("basedoc") !== -1){
        $('.main-navigation li.level1').removeClass('current-menu-item');
        $('.main-navigation li.level1#menu-item-basedoc').addClass('current-menu-item');
    }
    //Home
    else {
        $('.main-navigation li.level1').removeClass('current-menu-item');
        $('.main-navigation li.level1#menu-item-accueil').addClass('current-menu-item');
    }

}
